import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type ChangeEmailRoute from 'frontend-login/routes/change-email';
import type { ModelFrom } from 'frontend-login/utils/routes';

interface ChangeEmailResponse {
  response: Response;
}
export default class LoginController extends Controller {
  declare model: ModelFrom<ChangeEmailRoute>;
  queryParams = ['newEmail', 'next'];

  @service declare customFetch: Services['custom-fetch'];
  @service declare errorTracking: Services['error-tracking'];
  @service declare router: Services['router'];

  @tracked newEmail = '';
  @tracked showSuccessScreen = false;

  @action
  async confirmEmailChange(): Promise<void> {
    const { changeEmailCode } = this.model;

    if (!changeEmailCode) {
      this.redirectToLogin(true);
      return;
    }

    if (this.newEmail) {
      this.errorTracking.setUser({ email: this.newEmail });
    }

    try {
      const result = await this.customFetch.post<ChangeEmailResponse>(
        `/sso/change-email/${changeEmailCode}/`,
        {},
        {},
      );
      if (result.response.ok) {
        this.showSuccessScreen = true;
      } else {
        this.errorTracking.captureException(result);
        this.redirectToLogin(true);
      }
    } catch (error) {
      this.errorTracking.captureException(error);
      this.redirectToLogin(true);
    }
  }

  @action
  redirectToLogin(showError = false): void {
    this.router.transitionTo('login', {
      queryParams: { showGenericError: showError },
    });
  }
}
